import {
  createVehicleWithChauffeur,
  duplicateVehicleWithChauffeur,
  findVehicleWithChauffeur,
  updateVehicleWithChauffeur,
} from '@/api/vehicleWithChauffeur.api';
import { invalidateBenefitLists } from '@/hooks/useBenefits';
import { queryKeys } from '@/queryKeys';
import { SupportedLocale } from '@/types/supported-locale.type';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useCreateVehicleWithChauffeur = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: FormData) => createVehicleWithChauffeur(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.vehiclesWithChauffeur.all,
      });
      invalidateBenefitLists(queryClient);
    },
  });
};

export const useUpdateVehicleWithChauffeur = (language?: SupportedLocale) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ benefitId, data }: { benefitId: string; data: FormData }) =>
      updateVehicleWithChauffeur(benefitId, data, language),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.vehiclesWithChauffeur.all,
      });
      invalidateBenefitLists(queryClient);
    },
  });
};

export const useGetVehicleWithChauffeur = (benefitId: string) =>
  useQuery({
    queryKey: queryKeys.vehiclesWithChauffeur.detail(benefitId),
    queryFn: () => findVehicleWithChauffeur(benefitId),
  });

export const useDuplicateVehicleWithChauffeur = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      benefitId,
      fields,
    }: {
      benefitId: string;
      fields: string[];
    }) => duplicateVehicleWithChauffeur(benefitId, fields),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.vehiclesWithChauffeur.all,
      });
      invalidateBenefitLists(queryClient);
    },
  });
};
